"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _Typography = _interopRequireWildcard(require("../Typography"));
var _zeroStyled = require("../zero-styled");
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _cardHeaderClasses = _interopRequireWildcard(require("./cardHeaderClasses"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, _composeClasses.default)(slots, _cardHeaderClasses.getCardHeaderUtilityClass, classes);
};
var CardHeaderRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        return [
            _define_property({}, "& .".concat(_cardHeaderClasses.default.title), styles.title),
            _define_property({}, "& .".concat(_cardHeaderClasses.default.subheader), styles.subheader),
            styles.root
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
var CardHeaderAvatar = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar',
    overridesResolver: function(props, styles) {
        return styles.avatar;
    }
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
var CardHeaderAction = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Action',
    overridesResolver: function(props, styles) {
        return styles.action;
    }
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
var _obj;
var CardHeaderContent = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Content',
    overridesResolver: function(props, styles) {
        return styles.content;
    }
})((_obj = {
    flex: '1 1 auto'
}, _define_property(_obj, ".".concat(_Typography.typographyClasses.root, ":where(& .").concat(_cardHeaderClasses.default.title, ")"), {
    display: 'block'
}), _define_property(_obj, ".".concat(_Typography.typographyClasses.root, ":where(& .").concat(_cardHeaderClasses.default.subheader, ")"), {
    display: 'block'
}), _obj));
var CardHeader = /*#__PURE__*/ React.forwardRef(function CardHeader(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    var action = props.action, avatar = props.avatar, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, _props_disableTypography = props.disableTypography, disableTypography = _props_disableTypography === void 0 ? false : _props_disableTypography, subheaderProp = props.subheader, subheaderTypographyProps = props.subheaderTypographyProps, titleProp = props.title, titleTypographyProps = props.titleTypographyProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, other = _object_without_properties(props, [
        "action",
        "avatar",
        "component",
        "disableTypography",
        "subheader",
        "subheaderTypographyProps",
        "title",
        "titleTypographyProps",
        "slots",
        "slotProps"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        component: component,
        disableTypography: disableTypography
    });
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread({
            title: titleTypographyProps,
            subheader: subheaderTypographyProps
        }, slotProps)
    };
    var title = titleProp;
    var _ref = _sliced_to_array((0, _useSlot.default)('title', {
        className: classes.title,
        elementType: _Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'h5',
            component: 'span'
        }
    }), 2), TitleSlot = _ref[0], titleSlotProps = _ref[1];
    if (title != null && title.type !== _Typography.default && !disableTypography) {
        title = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleSlot, _object_spread_props(_object_spread({}, titleSlotProps), {
            children: title
        }));
    }
    var subheader = subheaderProp;
    var _ref1 = _sliced_to_array((0, _useSlot.default)('subheader', {
        className: classes.subheader,
        elementType: _Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'body1',
            color: 'textSecondary',
            component: 'span'
        }
    }), 2), SubheaderSlot = _ref1[0], subheaderSlotProps = _ref1[1];
    if (subheader != null && subheader.type !== _Typography.default && !disableTypography) {
        subheader = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SubheaderSlot, _object_spread_props(_object_spread({}, subheaderSlotProps), {
            children: subheader
        }));
    }
    var _ref2 = _sliced_to_array((0, _useSlot.default)('root', {
        ref: ref,
        className: classes.root,
        elementType: CardHeaderRoot,
        externalForwardedProps: _object_spread_props(_object_spread({}, externalForwardedProps, other), {
            component: component
        }),
        ownerState: ownerState
    }), 2), RootSlot = _ref2[0], rootSlotProps = _ref2[1];
    var _ref3 = _sliced_to_array((0, _useSlot.default)('avatar', {
        className: classes.avatar,
        elementType: CardHeaderAvatar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), AvatarSlot = _ref3[0], avatarSlotProps = _ref3[1];
    var _ref4 = _sliced_to_array((0, _useSlot.default)('content', {
        className: classes.content,
        elementType: CardHeaderContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), ContentSlot = _ref4[0], contentSlotProps = _ref4[1];
    var _ref5 = _sliced_to_array((0, _useSlot.default)('action', {
        className: classes.action,
        elementType: CardHeaderAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), ActionSlot = _ref5[0], actionSlotProps = _ref5[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, _object_spread_props(_object_spread({}, rootSlotProps), {
        children: [
            avatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)(AvatarSlot, _object_spread_props(_object_spread({}, avatarSlotProps), {
                children: avatar
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ContentSlot, _object_spread_props(_object_spread({}, contentSlotProps), {
                children: [
                    title,
                    subheader
                ]
            })),
            action && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionSlot, _object_spread_props(_object_spread({}, actionSlotProps), {
                children: action
            }))
        ]
    }));
});
process.env.NODE_ENV !== "production" ? CardHeader.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display in the card header.
   */ action: _propTypes.default.node,
    /**
   * The Avatar element to display.
   */ avatar: _propTypes.default.node,
    /**
   * @ignore
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: _propTypes.default.elementType,
    /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */ disableTypography: _propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        action: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        avatar: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        content: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        subheader: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        title: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        action: _propTypes.default.elementType,
        avatar: _propTypes.default.elementType,
        content: _propTypes.default.elementType,
        root: _propTypes.default.elementType,
        subheader: _propTypes.default.elementType,
        title: _propTypes.default.elementType
    }),
    /**
   * The content of the component.
   */ subheader: _propTypes.default.node,
    /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.subheader` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ subheaderTypographyProps: _propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The content of the component.
   */ title: _propTypes.default.node,
    /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.title` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ titleTypographyProps: _propTypes.default.object
} : void 0;
var _default = exports.default = CardHeader;
